import { render, staticRenderFns } from "./add-goods.vue?vue&type=template&id=19ccc4ce&scoped=true&"
import script from "./add-goods.vue?vue&type=script&lang=js&"
export * from "./add-goods.vue?vue&type=script&lang=js&"
import style0 from "./add-goods.vue?vue&type=style&index=0&id=19ccc4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ccc4ce",
  null
  
)

export default component.exports